import { ReceivedLineItemExecutionStatus } from "../../store/types";

export const getSerialList = (lineItem: ReceivedLineItemExecutionStatus, filterFunction: (s: any) => boolean) => {
    return lineItem?.containerizedMaterialStatusList?.reduce((total: any[], curr) => {
        const filteredList = curr?.receivedSerialList.filter(filterFunction).map(s => ({ ...s, containerId: curr?.containerId }));
        return total.concat(filteredList);
    }, []);
};
